// Open a checkout in a NEW tab, popup-blocker-safe. The blank tab MUST be
// opened synchronously inside the click gesture (browsers block window.open
// once an await has run), then navigated once the async checkout URL resolves.
// Mirrors the pattern in customerPortal.ts.

/** Open a blank tab within the current user gesture; returns the handle (or
 *  null if the browser blocked it even inside the gesture). */
export function openCheckoutTab(): Window | null {
  // No "noopener" — that makes window.open return null and we need the handle
  // to navigate once the URL resolves. We sever the opener ourselves below.
  return window.open("about:blank", "_blank");
}

/** Navigate a pre-opened tab to `url`, severing the opener first. Falls back to
 *  a same-tab redirect if the tab was blocked or has since been closed. */
export function navigateCheckoutTab(tab: Window | null, url: string): void {
  if (tab && !tab.closed) {
    try {
      tab.opener = null;
    } catch {
      // cross-origin after navigation — ignore
    }
    tab.location.href = url;
  } else {
    window.location.assign(url);
  }
}

/** Close a pre-opened tab when the checkout failed to start. */
export function closeCheckoutTab(tab: Window | null): void {
  if (tab && !tab.closed) tab.close();
}
